import React from "react";
import "./FeatureCard.css";

const FeatureCard = ({ title, description, badge, icon }) => {
  return (
    <article className="feature-card">
      {badge && <span className="feature-card__badge">{badge}</span>}

      <div className="feature-card__header">
        {icon && <div className="feature-card__icon">{icon}</div>}

        <h3 className="feature-card__title">{title}</h3>
      </div>

      {description && (
        <p className="feature-card__description">{description}</p>
      )}
    </article>
  );
};

export default FeatureCard;
